module.exports = __webpack_public_path__ + "img/fs_conf.dce8258f.png";